export default __webpack_public_path__ + "static/peachdish-project-d620ce2681e72d5ff084adf8fd7f0007.jpg";